<template>
  <footer v-show="isFooterBarVisible" class="footer">
    <div class="container-fluid">
      <div class="level">
        <div class="level-left">
          <div class="level-item is-size-7">
            &copy; {{ year }}, {{ config.footer }}
          </div>
        </div>
        <!-- <div class="level-right">
          <div class="level-item is-size-7">
            <router-link :to="{ name: 'About' }">About</router-link>
          </div>
          <div class="level-item is-size-7">
            <router-link :to="{ name: 'Legal' }">Legal</router-link>
          </div>
          <div class="level-item is-size-7">
            <router-link :to="{ name: 'Contact' }">Contact Us</router-link>
          </div>
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import config from '@/config'

export default {
  name: 'FooterBar',
  computed: {
    year() {
      return moment().year()
    },
    config() {
      return config
    },
    ...mapState(['isFooterBarVisible']),
  },
}
</script>
